'use client';

import { useCallback } from 'react';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { cn } from '@/lib/cn';

export function LobbyToolbar(): JSX.Element {
  const router = useRouter();
  const pathname = usePathname();
  const params = useSearchParams();
  const query = params.get('q') ?? '';

  const setQuery = useCallback(
    (q: string): void => {
      const next = new URLSearchParams(params.toString());
      if (!q) next.delete('q');
      else next.set('q', q);
      const qs = next.toString();
      router.replace(qs ? `${pathname}?${qs}` : pathname, { scroll: false });
    },
    [params, pathname, router],
  );

  return (
    <div className="flex flex-wrap items-center gap-3">
      <Tabs />
      <div className="flex-1 min-w-[180px]">
        <input
          type="search"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Search teams (e.g. Lakers, Chiefs)"
          className="w-full rounded-md border border-border bg-panel px-3 py-2 text-sm outline-none focus:border-accent"
          aria-label="Search games"
        />
      </div>
    </div>
  );
}

function Tabs(): JSX.Element {
  return (
    <div className="flex items-center gap-1 rounded-full bg-panel p-1" role="tablist">
      <button
        type="button"
        className={cn(
          'rounded-full px-4 py-1.5 text-sm font-semibold transition-colors',
          'bg-accent-strong text-white',
        )}
        aria-selected="true"
        role="tab"
      >
        Games
      </button>
      <button
        type="button"
        disabled
        title="Player props — coming soon"
        className="rounded-full px-4 py-1.5 text-sm text-muted opacity-60 cursor-not-allowed"
        aria-disabled="true"
        role="tab"
      >
        Props
      </button>
    </div>
  );
}
